import React, { useState } from "react";

// const faqData = [
//   {
//     question: "How do I know which medical college is best for my NEET rank?",
//     answer: (
//       <p>
//         Use the cutoff and closing rank data for each college to compare with your NEET rank. Also consider your category, quota, and state domicile status. Our college cards show last year’s cutoffs for all quotas and categories.
//       </p>
//     ),
//   },
//   {
//     question: "Are private and deemed universities included in this list?",
//     answer: (
//       <p>
//         Yes. The list covers government, private, deemed, and central institutions (including AIIMS, JIPMER, BHU, AMU, etc.) across India.
//       </p>
//     ),
//   },
//   {
//     question: "Where can I find the MBBS fee structure for each college?",
//     answer: (
//       <p>
//         Each college card displays the latest MBBS tuition fees, hostel charges, and other one-time fees for all quotas (Govt, Management, NRI, etc.).
//       </p>
//     ),
//   },
//   {
//     question: "Can I filter colleges by state, type, or cutoff?",
//     answer: (
//       <p>
//         Yes. You can filter colleges by state, type (government/private/deemed), category, and cutoff to create a personalized shortlist for counseling.
//       </p>
//     ),
//   },
//   {
//     question: "What documents are required for MBBS admission?",
//     answer: (
//       <p>
//         Common documents include NEET admit card, scorecard, 10th/12th certificates, ID proof, category/domicile certificates (if applicable), and college allotment letter. Each college card lists the required documents.
//       </p>
//     ),
//   },
//   {
//     question: "Are hostel and campus facilities shown for each college?",
//     answer: (
//       <p>
//         Yes. We provide details on hostel availability, mess, hospital beds, campus infrastructure, and other facilities in every college card.
//       </p>
//     ),
//   },
//   {
//     question: "How often is the college data updated?",
//     answer: (
//       <p>
//         The data is updated after every major counseling round and whenever official sources (NMC, MCC, state authorities) release new information.
//       </p>
//     ),
//   },
//   {
//     question: "Is there a girls’ hostel in every college?",
//     answer: (
//       <p>
//         Most government and private colleges have separate girls’ hostels. The college card mentions hostel details and facilities for both boys and girls.
//       </p>
//     ),
//   },
//   {
//     question: "Can I participate in both AIQ and state counseling?",
//     answer: (
//       <p>
//         Yes, you can register and participate in both All India Quota (MCC) and your state’s counseling. Admission rules and eligibility may differ for each.
//       </p>
//     ),
//   },
//   {
//     question: "What is the difference between Management and NRI quota?",
//     answer: (
//       <p>
//         Management quota seats are open to Indian students (with higher fees), while NRI quota seats are reserved for Non-Resident Indians/OCI/PIO candidates, often with separate eligibility and fee structure.
//       </p>
//     ),
//   },
// ];

const CollegeContent = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <div className="college-content w-full max-w-6xl mx-auto p-6 font-sans">
      <h2 className="text-3xl font-bold text-center mb-6">
        Top Medical Colleges in India –{" "}
        <span className="text-[#ff9245]">NEET 2026</span>
      </h2>
      <p className="mt-4 text-[16px]">
        The NEET 2026 exam opens doors to India’s top medical colleges, and picking
        the right one is crucial for your medical career. This page is here to help
        you find and compare the best MBBS colleges across India, including
        government, private, deemed, and autonomous institutions like AIIMS.
      </p>
      <p className="mt-4 text-[16px]">
        Here, you will find a full list of medical colleges in India, presented in a
        simple card format. Each card gives you easy access to important details
        such as fees, cutoff ranks, seat matrix, hostel facilities, and the
        admission process. Whether you’re aiming for All India Quota (AIQ), State
        Quota, or Management Quota, this guide will help you select the best
        college based on your NEET 2026 rank, category, and preferences.
      </p>

      <h3 className="text-2xl font-semibold mt-8">
        Understanding the Importance of College Selection in NEET Counselling
      </h3>
      <p className="mt-4 text-[16px]">
        After clearing NEET, the biggest challenge isn’t just getting a good score,
        but choosing the right college. With thousands of MBBS seats available under
        different quotas in various states, it can get confusing. Many students miss
        out on better options because they don’t have clear and updated college
        information.
      </p>
      <p className="mt-4 text-[16px]">
        This page is here to solve that problem. At NEET Support, we’ve gathered all
        the important details about medical colleges in one place. This will help you
        compare colleges easily and make informed decisions during the counseling
        process.
      </p>

      <h3 className="text-2xl font-semibold mt-8">
        What Does Each College Card Include?
      </h3>
      <p className="mt-4 text-[16px]">
        Every card displayed on this page provides a concise summary of the college,
        along with a link to detailed information. Here's what you’ll find in each:
      </p>
      <ol className="list-decimal list-inside mt-4 space-y-4 pl-6">
        <li>
          <b>Basic College Information</b>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>College name and address</li>
            <li>State and city location</li>
            <li>Type of college (Government, Private, Deemed, Central, AIIMS)</li>
            <li>Year of establishment and NMC recognition status</li>
            <li>Affiliated university</li>
          </ul>
        </li>
        <li>
          <b>MBBS Fees Structure</b>
           <p>Understanding the fee is essential for planning your finances. We show:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Annual tuition fees for MBBS course</li>
            <li>Hostel and mess charges (if applicable)</li>
            <li>One-time fees (security deposit, admission charges, etc.)</li>
            <li>Fee structure for different quotas like Govt, Management, NRI</li>
          </ul>
          <p className="mt-2 text-[16px]">
            This helps students compare not just on merit, but also on affordability.
          </p>
        </li>
        <li>
          <b>NEET Cutoff and Rank Trends</b>
          <p>We display the most recent NEET UG cutoff data including:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Round-wise opening and closing ranks</li>
            <li>Category-wise (UR, OBC, SC, ST, EWS, PWD)</li>
            <li>Quota-wise (AIQ, State, Management, NRI)</li>
            <li>Yearly comparison (for colleges with multiple years of data)</li>
          </ul>
          <p className="mt-2 text-[16px]">
            This data is crucial for rank-based prediction and for planning choice
            filling in NEET UG counseling.
          </p>
        </li>
        <li>
          <b>Seat Matrix and Intake</b>
          <p>Students often look for colleges with more seats and open quotas. Each card includes:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Total MBBS intake (typically 100, 150, or 250 seats)</li>
            <li>Quota-wise seat distribution (AIQ, State, Management, NRI)</li>
            <li>Category-wise reservation as per the state/central policies</li>
          </ul>
        </li>
        <li>
          <b>Hospital Facilities and Infrastructure</b>
          <p>Real medical learning depends on hospital exposure. So we include:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Total number of teaching hospital beds</li>
            <li>OPD/IPD strength</li>
            <li>ICU, emergency services, and lab facilities</li>
            <li>Hostel availability and campus infrastructure (library, lecture halls, etc.)</li>
          </ul>
        </li>
        <li>
          <b>Admission and Counseling Details</b>
          <p>Every college follows a specific counseling route:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Whether admission is through MCC (AIQ/Deemed) or State counseling</li>
            <li>Eligibility for state domicile students</li>
            <li>Documents required for admission</li>
            <li>Any bond service requirements (e.g., rural posting obligations)</li>
          </ul>
        </li>
        <li>
          <b>Frequently Asked Questions</b>
          <p>Each college section also includes a set of FAQs commonly asked by students, such as:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>What was last year’s closing rank?</li>
            <li>Does the college have a girls’ hostel?</li>
            <li>What is the food and accommodation like?</li>
            <li>Are internships paid?</li>
            <li>What is the dress code or uniform policy?</li>
          </ul>
        </li>
      </ol>

      <h3 className="text-2xl font-semibold mt-8">
        Categories of Medical Colleges Covered
      </h3>
      <p className="mt-4 text-[16px]">
        We’ve listed colleges from every type and location in India, including:
      </p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>AIIMS and Central Universities like AIIMS Delhi, BHU, AMU</li>
        <li>Top Government Medical Colleges like MAMC Delhi, GMC Mumbai, SMS Jaipur</li>
        <li>Private MBBS Colleges including KMC Manipal, CMC Ludhiana, D.Y. Patil</li>
        <li>Deemed Universities such as JIPMER, SRM, Saveetha, BVDU</li>
        <li>State-wise Listings for UP, Maharashtra, Rajasthan, Kerala, Tamil Nadu, and more</li>
      </ul>

      <h3 className="text-2xl font-semibold mt-8">
        How This Page Helps You in NEET 2026 Counselling
      </h3>
      <p className="mt-4 text-[16px]">
        With thousands of aspirants competing, and many colleges offering
        similar-sounding promises, clarity is key. This page is not just a list—it’s a
        smart tool to plan your entire NEET UG counselling strategy.
      </p>
      <p className="mt-4 text-[16px]">
        Use this page to:
      </p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>Compare colleges by rank, fees, or location</li>
        <li>Filter colleges based on state, type, category, or cutoff</li>
        <li>Access college-specific info without searching multiple sites</li>
        <li>Create a shortlist for choice filling during counseling rounds</li>
      </ul>

      <h3 className="text-2xl font-semibold mt-8">
        Why Use NEET Support’s College List?
      </h3>
      <p className="mt-4 text-[16px]">
        There are many lists online, but most are outdated, confusing, or full of
        promotional content. NEET Support gives you:
      </p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>Official data sourced from NMC, MCC, and state websites</li>
        <li>Counseling-focused information—not just brochure content</li>
        <li>Real cutoffs and rank ranges—not estimates</li>
        <li>Mobile-friendly interface—explore college data on the go</li>
        <li>Regular updates for every counseling round</li>
      </ul>
      <p className="mt-4 text-[16px]">
        We built this tool for NEET students, not marketers.
      </p>

      {/* <section className="w-full max-w-7xl mx-auto mt-14 mb-16 sm:mb-0">
        <h2
          className="sm:text-3xl text-2xl font-bold text-center capitalize"
          style={{ color: "#140342", fontSize: "28.125px" }}
        >
          Frequently asked{" "}
          <span className="text-[#ff9245]">questions</span>
        </h2>
        <div className="mt-8 space-y-4 ml-6 mr-6">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`p-4 border rounded-lg shadow-md ${
                activeFAQ === index ? "bg-gray-50" : ""
              }`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center cursor-pointer">
                <h3
                  className="text-lg font-semibold"
                  style={{ color: "#140342", fontSize: "16.875px" }}
                >
                  {faq.question}
                </h3>
                <span>{activeFAQ === index ? "-" : "+"}</span>
              </div>
              <div
                className={`mt-2 text-gray-600 text-left text-lg ${
                  activeFAQ === index ? "block" : "hidden"
                }`}
              >
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </section> */}
    </div>
  );
};

export default CollegeContent;
